module.exports = __webpack_public_path__ + "img/kontak-outline.acc81e95.svg";